module.exports = __webpack_public_path__ + "static/media/bulb.508592b3.png";